import { AsyncPipe } from '@angular/common';
import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  input,
} from '@angular/core';
import { timeLineService } from '@fitness-force/shared-utils';
import { BehaviorSubject } from 'rxjs';
import { MemberCrownComponent } from '../member-crown/member-crown.component';

@Component({
  selector: 'member-since-large',
  templateUrl: './member-since-large.component.html',
  styleUrls: ['./member-since-large.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MemberCrownComponent, AsyncPipe],
})
export class MemberSinceLargeComponent implements OnInit {
  readonly columnData = input(new BehaviorSubject(null));
  dateValue!: string;
  constructor() {}

  ngOnInit(): void {
    // Get the BehaviorSubject from the signal input and subscribe to it
    const columnDataSubject = this.columnData();
    if (columnDataSubject) {
      columnDataSubject.subscribe((value: any) => {
        if (new Date(value?.client_since) > new Date(value?.created_date)) {
          this.dateValue = value?.client_since;
        } else {
          this.dateValue = value?.created_date;
        }
      });
    }
  }
  memberSince(fromDate: string) {
    return timeLineService(fromDate);
  }
}
